import { useState } from 'react';

export const useSwitch = () => {
  const [isOn, setIsOn] = useState<boolean>(false);
  const onSwitchChange = (val: boolean) => setIsOn(val);
  return { onSwitchChange, isOn };
};
